module.exports = __webpack_public_path__ + "img/dots.97d53006.svg";